import { Checkbox, type TypeCheckboxProps } from '@thefarmersfront/kitchen';

import type { CustomCellRendererProps } from 'ag-grid-react';
import clsx from 'clsx';

import styles from './TableCellRenderer.module.scss';

type TypeCheckboxCellProps<TData, TValue> = CustomCellRendererProps<TData, TValue> & TypeCheckboxProps;

const CheckboxCell = <TData, TValue extends boolean>({
  value,
  disabled,
  status,
  validationMessage,
  onChange,
  label,
}: TypeCheckboxCellProps<TData, TValue>) => {
  return (
    <div className={clsx(styles['cell-wrapper'], styles['checkbox'])}>
      <Checkbox
        size="medium"
        label={label}
        status={status}
        validationMessage={validationMessage}
        disabled={disabled ?? false}
        checked={value ?? false}
        onChange={onChange}
      />
    </div>
  );
};

export default CheckboxCell;
